// extracted by mini-css-extract-plugin
export default {"layout":"_39c8985871 _82018c6c4a _32edaa3baf","h_slide":"_5264365d44","category":"_59988d4189 _23e4ec4a4d _52b7c8b71c"};